import type { PublicUserProfile, User } from "@fitties/shared";
import { isGender } from "@fitties/shared";
import { calculateAge } from "@shared/utils/ageUtils";

function toIsoOrNull(value: Date | undefined): string | null {
  if (!value || Number.isNaN(value.getTime())) {
    return null;
  }
  return value.toISOString();
}

export function toDiscoveryPreviewProfile(user: User): PublicUserProfile | null {
  const displayName = user.display_name?.trim() ?? "";
  const photoUrl = user.photo_url?.trim() ?? "";
  const gender = isGender(user.gender) ? user.gender : null;
  const desiredGenders = (user.desired_genders ?? []).filter(isGender);
  const age = user.date_of_birth ? calculateAge(user.date_of_birth) : null;

  if (!displayName || !photoUrl || !gender || age === null) {
    return null;
  }

  return {
    uid: user.uid,
    display_name: displayName,
    bio: user.bio ?? "",
    photo_url: photoUrl,
    age,
    gender,
    desired_genders: desiredGenders,
    lastKnownEventEnteredAt: toIsoOrNull(user.lastKnownEventEnteredAt),
    ...(user.bioContent ? { bioContent: user.bioContent } : {}),
  };
}
